(function(window,$) {

	var tag = document.createElement('script');
	tag.src = "https://www.youtube.com/iframe_api";
	var firstScriptTag = document.getElementsByTagName('script')[0];
	firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

	var player,
		done = false;

	window.onYouTubeIframeAPIReady = function() {
		player = new YT.Player('app_youtube-replace', {
			videoId: 'hpRQo0yD-FU',
			playerVars: {
				wmode: 'transparent'
			},
			events: {
				'onReady': onPlayerReady,
				'onStateChange': onPlayerStateChange
			}
		});
	};

	function onPlayerReady() {
		$('.app_youtube-play').click(function() {
			$('.app_youtube-cover').fadeOut(400);
			player.playVideo();
		});
	}

	function onPlayerStateChange(event) {
		if (event.data == YT.PlayerState.ENDED && !done) {
			setTimeout(function() {player.stopVideo();}, 6000);
			done = true;
			$('.app_youtube-cover').fadeIn(400);
		}
	}

})(window,jQuery);
